import { createContext } from 'react'
import type {
  CompanySuspensionQuery,
  TotalServicesQuery,
  UserCompaniesQuery,
  UserPermissionsQuery,
  CompanyBillingQuery,
  SamlInterstitialQuery,
} from '@/components/root/gql.types.gen'
import type { QueryRef } from '@apollo/client'

type Context = {
  userCompaniesQueryRef: QueryRef<UserCompaniesQuery>
  userPermissionsQueryRef: QueryRef<UserPermissionsQuery>
  totalServicesQueryRef: QueryRef<TotalServicesQuery>
  companySuspensionQueryRef: QueryRef<CompanySuspensionQuery>
  companyBillingQueryRef: QueryRef<CompanyBillingQuery>
  samlInterstitialQueryRef: QueryRef<SamlInterstitialQuery>
}

export const QueryRefsContext = createContext<Context>({} as Context)
